/**
 * Deep-Link ins OTA-Extranet — konservativ. Booking.com Extranet hat ein hotel_id-
 * Query-Param, ist aber nur für eingeloggte Eigentümer-Accounts. Airbnb hat eine
 * öffentliche Listing-URL. Unbekannte Kanäle → kein Link (null).
 */
export function buildOtaUrl(channel: string, externalId: string | null): string | null {
  if (!externalId) return null;
  switch (channel) {
    case 'BookingCom':
      return `https://admin.booking.com/hotel/hoteladmin/extranet_ng/manage/home.html?hotel_id=${externalId}`;
    case 'Airbnb':
      return `https://www.airbnb.com/rooms/${externalId}`;
    default:
      return null;
  }
}
